import { useForm } from 'modules/core/hooks/useForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateTag } from 'modules/ats/hooks/tags/useCreateTag'
import { Tag } from 'modules/ats/hooks/tags/useTags'

interface Props {
  tags?: Tag[]
  companyId: number
}

interface TagFormValues {
  name: string
  companyId?: number
}

export const useCreateTagForm = ({ companyId }: Props) => {
  const { loading: creating, create } = useCreateTag()

  const createTagForm = useForm<TagFormValues>({
    defaultValues: {
      name: '',
    },
    async onSubmit(data, { setErrors }) {
      const result = await create({
        name: data.name,
        companyId,
      })

      const handled = handleResult(result, ({ messages }) => {
        setErrors({
          name: messages,
        })
      })

      if (handled.success) {
        app.setFlash({ type: 'correct', message: i18n.t('common.saved_successfully'), time: 2000 })
        track(trackingEvents.ats.createTag, { source: 'TagManager' })
        createTagForm.resetForm()
      }

      return handled
    },
  })

  return {
    creating,
    createTagForm,
  }
}
